import type { ReactNode } from 'react';

import { cx } from './cx';
import type { Tone } from './Pill';

const INK: Record<Tone, string> = {
  neutral: '',
  ok: 'text-ok',
  warn: 'text-warn',
  danger: 'text-danger',
  info: 'text-info',
  brand: 'text-brand',
};

/**
 * The headline figure above a report: a caps label, the number at 22px, and one line
 * underneath saying what qualifies it.
 *
 * The second line is where "of which 14 charged" goes. Without it the tile is a number
 * somebody has to go and check in the table below, which is the opposite of what a headline
 * is for.
 */
export function StatTile({
  label,
  value,
  sub,
  tone = 'neutral',
  className,
}: {
  label: ReactNode;
  value: ReactNode;
  sub?: ReactNode;
  tone?: Tone;
  className?: string;
}) {
  return (
    <div className={cx('flex flex-col gap-0.5 px-4 py-3', className)}>
      <span className="text-caps font-semibold tracking-[0.06em] uppercase text-ink-3">
        {label}
      </span>
      <span className={cx('text-stat font-semibold tracking-[-0.01em] leading-[1.2]', INK[tone])}>
        {value}
      </span>
      {sub ? <span className="text-secondary text-ink-3">{sub}</span> : null}
    </div>
  );
}
